<template>
  <div>
    <v-btn outline color="primary" @click="handleDownloadTemplate">
      <em class="fas fa-download" />&nbsp;&nbsp;{{ $t('download_template') }}
    </v-btn>
  </div>
</template>

<script>
import * as XLSX from 'xlsx'

export default {
  methods: {
    handleDownloadTemplate() {
      const sheet1Heading = [['*CategoryName']]
      const sheet2Heading = [
        [
          '*CategoryName',
          '*ProductName',
          'ImageURL',
          'ProductDesc',
          '*Keyword',
          'StartTime',
          'EndTime',
          'ButtonName',
          'ButtonPayload',
          '*Option1',
          'Option2',
          '*Quantity',
          '*Price',
          'DiscountPrice',
          'Weight',
          '*SKU',
          '*IntentName',
          '*IntentType',
          'ContextIn',
          'ContextOut',
          '*AdjustStock (Y/N)'
        ]
      ]

      const wb = XLSX.utils.book_new()
      const dataWS1 = XLSX.utils.json_to_sheet([[]])
      const dataWS2 = XLSX.utils.json_to_sheet([[]])

      XLSX.utils.sheet_add_aoa(dataWS1, sheet1Heading)
      XLSX.utils.sheet_to_json(dataWS1, { origin: 'A2', skipHeader: true })
      XLSX.utils.book_append_sheet(wb, dataWS1, 'Category')

      XLSX.utils.sheet_add_aoa(dataWS2, sheet2Heading)
      XLSX.utils.sheet_to_json(dataWS2, { origin: 'A2', skipHeader: true })
      XLSX.utils.book_append_sheet(wb, dataWS2, 'Option')

      XLSX.writeFile(wb, `zwiz_product_template.xlsx`)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/DownloadImportTemplateCds.vue